import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LanguageService } from '@core/services/language.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-fatwa',
  templateUrl: './add-fatwa.component.html',
  styleUrls: ['./add-fatwa.component.scss']
})
export class AddFatwaComponent implements OnInit {
formData: any = {
  fatwa_category_id: '',
  question: '',
  answer: ''
};
   public arrCoupons: any[] = [];
  public lang : any
categories: any[] = [];

    public currentLang : string
errors: any = {}; // store validation errors

  
  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService,private language : LanguageService
  ) {}

    ngOnInit(): void {
                this.currentLang = localStorage.getItem('currentLang')
   this.language.currentLang.subscribe((res: string) => {
this.lang = res; 
});
this.getLevels();


                  this.apisService.users().subscribe({ 
      next:(response:any)=> { 
        this.arrCoupons = response.data.data || [] ;
        console.log('response is' , this.arrCoupons)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })


    }
onFileSelected(event: any) {
  const file: File = event.target.files[0];
  this.formData.image = file.name; // send only file name ✔
}

getLevels() {
  this.apisService.categories().subscribe({
    next: (response: any) => {
      this.categories = response.data || [];
      console.log('categories', this.categories);
    },
    error: (err) => {
      console.log('error in fetching', err);
    }
  });
}
    cancel(): void {
      this.router.navigate(['/FATWA']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }


    
    /*----------  Submitting the form  ----------*/
    
    /*----------  Submitting the form  ----------*/
onSubmit() {
  this.errors = {}; // reset previous errors

 const payload = {
  fatwa_category_id: this.formData.fatwa_category_id,
    answer: this.formData.answer,
    question: this.formData.question,
  };

  this.apisService.addfatwa(payload).subscribe({
   next: () => {
  this.toastr.success(
    this.currentLang === 'ar'
      ? 'تمت الإضافة بنجاح'
      : 'Added successfully'
  );

  this.router.navigate(['/FATWA']);
},

error: () => {
  this.toastr.error(
    this.currentLang === 'ar'
      ? 'حدث خطأ أثناء الإضافة'
      : 'Error adding'
  );
}

  });
}


}